import React from 'react';
import { MailOutlined, ClockCircleOutlined, MessageOutlined } from '@ant-design/icons';
import PublicPageLayout from './PublicPageLayout';

const SupportPage = () => (
  <PublicPageLayout title="Support" subtitle="We're here to help you with GuffPuff">
    <div className="space-y-8 text-gray-700 leading-relaxed" style={{ fontSize: '15px', lineHeight: '1.8' }}>
      <section>
        <h2 className="text-xl font-bold text-gray-800 mb-3">Contact GuffPuff Support</h2>
        <p>
          If you need help with your account, subscriptions, technical issues, or have any questions
          about GuffPuff, our support team is ready to assist you.
        </p>
      </section>

      <section className="bg-cyan-50 rounded-xl p-6 border border-cyan-100">
        <div className="flex items-start gap-3">
          <MailOutlined className="text-cyan-600 text-xl mt-1" />
          <div>
            <h3 className="font-semibold text-gray-800 mb-1">Email Support</h3>
            <p className="text-gray-600 mb-2">Send us an email and we will get back to you as soon as possible.</p>
            <a href="mailto:support@guffpuff.com" className="text-cyan-600 font-semibold hover:underline">
              support@guffpuff.com
            </a>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 rounded-xl p-6 border border-gray-100">
        <div className="flex items-start gap-3">
          <ClockCircleOutlined className="text-cyan-600 text-xl mt-1" />
          <div>
            <h3 className="font-semibold text-gray-800 mb-1">Response Time</h3>
            <p className="text-gray-600">
              We typically respond within 24–48 business hours. Premium members receive priority support.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 rounded-xl p-6 border border-gray-100">
        <div className="flex items-start gap-3">
          <MessageOutlined className="text-cyan-600 text-xl mt-1" />
          <div>
            <h3 className="font-semibold text-gray-800 mb-1">In-App Contact</h3>
            <p className="text-gray-600">
              You can also reach us through the Contact Us form inside the GuffPuff mobile app.
              Go to <strong>Settings → Help &amp; Support → Contact Us</strong>.
            </p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-800 mb-3">Common Topics</h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>Account login and password issues</li>
          <li>Subscription and billing questions</li>
          <li>Reporting inappropriate content or users</li>
          <li>Privacy and data requests</li>
          <li>Account deletion requests</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-800 mb-3">Legal &amp; Privacy</h2>
        <p className="text-gray-600">
          For privacy-related requests, contact{' '}
          <a href="mailto:privacy@guffpuff.com" className="text-cyan-600 hover:underline">
            privacy@guffpuff.com
          </a>
          . For legal matters, contact{' '}
          <a href="mailto:legal@guffpuff.com" className="text-cyan-600 hover:underline">
            legal@guffpuff.com
          </a>
          .
        </p>
      </section>
    </div>
  </PublicPageLayout>
);

export default SupportPage;
